import Model from "./model";
import CategoryLevel from "./category-level";
import ListColumnWidth from "./list-column-width";
import OrderAction from "./order-action";
import EntryColor from "./entry-color";
import ProductModifier from "./product-modifier";
import ImageMaxWidth from "./image-max-width";

// 基础地址

// const BaseUrl = "http://localhost:3001";
const BaseUrl = "https://mall.tongnianjihua.com";
// const BaseUrl = "https://shop.tongnianjihua.com";

// 课消接口地址
const SignInBaseUrl = BaseUrl;

// CDN
const CdnUrl = `${BaseUrl}/public/files`;

// 管理接口地址
const ApiUrl = `${BaseUrl}/admin`;

// 前端接口地址
const PublicApiUrl = `${BaseUrl}/public`;

// 分页大小
const PageSize = 10;

// 网站标题
const Title = "网站后台";

export default {
  Model,
  CategoryLevel,
  ListColumnWidth,
  OrderAction,
  EntryColor,
  ProductModifier,
  ImageMaxWidth,
  BaseUrl,
  SignInBaseUrl,
  CdnUrl,
  ApiUrl,
  PublicApiUrl,
  PageSize,
  Title
};
